import { batchAddMissingMessages, getChannelInfo } from '../../../Slice';
import Store from '../../../Store';

/**
 * Handle MISSING_MESSAGE_PUBLISHED event
 * This event contains an array of messages that were missing and need to be inserted
 * based on their sequenceId to fill gaps in the conversation
 */
export const handleMissingMessagePublished = messagesData => {
   try {
      if (!Array.isArray(messagesData) || messagesData.length === 0) {
         console.warn('Missing messages data is not an array or is empty');
         return;
      }

      // Group messages by channelId
      const messagesByChannel = messagesData.reduce((acc, message) => {
         const { channelId } = message;
         if (!acc[channelId]) {
            acc[channelId] = [];
         }
         acc[channelId].push(message);
         return acc;
      }, {});

      // Prepare data for batch update
      const batchData = {};

      // Process each channel's missing messages
      Object.entries(messagesByChannel).forEach(([channelId, messages]) => {
         try {
            // Check if channel is initialized
            const hasInitialized = Store.getState()?.channelConversationData?.channelUiState?.[channelId]?.initialized;

            if (!hasInitialized) {
               return;
            }

            // Transform messages to match the expected format
            const transformedMessages = messages.map(message => ({
               ...message,
               createdAt: new Date(message.messageTime).toISOString(),
               updatedAt: new Date(message.messageTime).toISOString(),
               editedAt: message.editedAt || null,
               deletedAt: null,
               meta: message.meta || null,
            }));

            // Sort messages by sequenceId to ensure proper order
            transformedMessages.sort((a, b) => a.sequenceId - b.sequenceId);

            const channelInfo = getChannelInfo(channelId);
            const lastReadMessageId = channelInfo?.lastReadMessage?.messageId;
            const isViewing = isUserViewingChannel(channelId);


            // Add to batch data
            batchData[channelId] = {
               messages: transformedMessages,
               lastReadMessageId,
               unreadCount: channelInfo?.unreadCount || 0,
               isViewing,
            };
         } catch (error) {
            console.error(`Failed to prepare missing messages for channel ${channelId}:`, error);
         }
      });

      // Single Redux dispatch for all channels
      if (Object.keys(batchData).length > 0) {

         Store.dispatch(
            batchAddMissingMessages({
               messagesByChannel: batchData,
            }),
         );

      }
   } catch (error) {
      console.error('Failed to handle MISSING_MESSAGE_PUBLISHED event:', error);
   }
};

/**
 * Check if user is currently viewing the channel
 */
const isUserViewingChannel = channelId => {
   try {
      const activeChannel = Store.getState().channelNavData?.activeConversationChannel;
      return activeChannel?.channelId === channelId;
   } catch (error) {
      return false;
   }
};
